import Vue from 'vue'
import App from './App.vue'

import 'utils/vue-prototype-extend'
import 'plugins/vant'
import 'style/common.css'
import store from 'store';
import 'plugins/clipboard'
import '../src/assets/iconfont/iconfont.css'


//全局组件
import AllComponents from 'components'
Vue.use(AllComponents);
Vue.config.productionTip = false;
Vue.config.ignoredElements = ['wx-open-launch-weapp'];//注册wx-open-launch-weapp组件
// import VConsole from 'vconsole';
// Vue.prototype.$vconsole = new VConsole();

import router from './router'
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
